import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

import * as myConstClass from '../../shared/constants/constants';

const DASHMOD_NBOF_DATACOL = 7;
const PAGER_DISPPAGES = 4;
const PAGER_PAGESIZE = 10;

class DashMod_GameResultsPlayerAll01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			resultTableData: [],
			sortFieldIdx: 0,
			sortOrder: 'desc',	// date desc by default
			sortClass: [],
			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE-1,
				totalItems: 0
			},
			loading: true
		};
	
		this.createTableRow = this.createTableRow.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
    // console.log('DashMod01: componentDidMount');
    const { playerId } = this.props;
    if (playerId) {
      this.initiatePagerSizeWithData();
    } else {
      this.setState({ loading: false });
    }
	}

  componentDidUpdate(prevProps) {
    if (
      prevProps.playerId !== this.props.playerId ||
      prevProps.resultsType !== this.props.resultsType ||
      prevProps.leagueType !== this.props.leagueType
    ) {
      if (this.props.playerId) {
        this.initiatePagerSizeWithData();
      } else {
        this.setState({ loading: false, resultTableData: [], pager: { ...this.state.pager, totalItems: 0, totalPages: 0, pages: [] } });
      }
    }
  }

	initiatePagerSizeWithData() {
    // console.log('DashMod01: initiatePagerSizeWithData');
    const { playerId, resultsType, leagueType } = this.props;

		var sortClass = ['asc'];
		for(var i = 1; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[this.state.sortFieldIdx] = "statelo-sorting_" + this.state.sortOrder;

    if (!playerId) {
      this.setState({ loading: false });
      return;
    }

		this.setState({
			sortClass: sortClass,
      loading: true,
		});

		Axios.get('/api/dashmod/gameResults/size/' + 
			'playerId/' + playerId + 
			'/resultsType/' + resultsType	+ 
			'/leagueType/' + leagueType)
		.then(response => {
			
			// Init pager
			var pager = {
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				startindex: 0,
				endIndex: PAGER_PAGESIZE-1,
				totalItems: response.data.count,
			};

			this.setPage(1, pager);
		});
	}

  setPage(page, pager) {
    // console.log('DashMod01: setPage');
  	// set optional parameters
    var pager = pager || this.state.pager;

    if (page < 1 || page > pager.totalPages) {
    	console.log('************ ERR *************');
    	console.log('setPage unexpected return');
    	return;
    }

    // get new pager object for specified page
    pager = this.getPager(pager.totalItems, page);

    // call change page function in parent component
    this.loadData(pager, this.state.sortFieldIdx, this.state.sortOrder);
  }

	getPager(totalItems, currentPage, pageSize) {

	  // default to first page
	  currentPage = currentPage || 1;

	  // default page size is 10
	  pageSize = pageSize || PAGER_PAGESIZE;

	  // calculate total pages
	  var totalPages = Math.ceil(totalItems / pageSize);

	  var startPage, endPage;
	  if (totalPages <= PAGER_DISPPAGES) {
	      // less than 10 total pages so show all
	      startPage = 1;
	      endPage = totalPages;
	  } else {
	      // more than 10 total pages so calculate start and end pages
	      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
	          startPage = 1;
	          endPage = PAGER_DISPPAGES;
	      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
	          startPage = totalPages - (PAGER_DISPPAGES - 1);
	          endPage = totalPages;
	      } else {
	          startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
	          endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
	      }
	  }

	  // calculate start and end item indexes
	  var startIndex = (currentPage - 1) * pageSize;
	  var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

	  // create an array of pages to ng-repeat in the pager control
	  // var pages = _.range(startPage, endPage + 1);		// lodash function
		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
    	return index + startPage;  
  	});
    
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData(pager, sortFieldIdx, sortOrder) {
		// console.log('DashMod - loadData');
		document.body.classList.add('busy-cursor');
    const { playerId, resultsType, leagueType } = this.props;

		Axios.get('/api/dashmod/gameResultsAll/playerId/' + playerId + 
			'/resultsType/' + resultsType + '/leagueType/' + leagueType + 
			'/start/' + pager.startIndex + '/end/' + (pager.endIndex + 1) + 
			'/sortFieldIdx/' + sortFieldIdx + '/sortOrder/' + sortOrder).
			then(response => {

				// console.log('response.data');
				// console.log(response.data);

				this.setState({
					pager: pager,
					resultTableData: response.data,
					loading: false
				});
				document.body.classList.remove('busy-cursor');
		});	
	}

	render() {
		// console.log('DashMod_GameResultsPlayerAll01: render');

		if (!this.props.playerId) return null;

    var { pager } = this.state;

		var bDispModule = true;
    if (pager.pages.length < 1) {
    	bDispModule = false;
    } 

		return (
			<div className="row db-module-outer-light">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-light">Vos parties jouées</h4>
				</div>
				</div>
	
				<div className="row db-module-inner-light">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-light">
					{bDispModule ? this.displayModule(pager) : 
						<div>
						<p>Aucune partie jouée</p>
						</div>
					}
				</div>
				</div>
				</div>
			</div>
			</div>
		)
	}

	displayModule(pager) {
		if (this.state.loading) {
			return (
				<div className="text-center margin-top-10">
					<i> données en chargement </i>
					{this.displaySpinner()}
				</div>
			);
		} else {
			return ( this.displayData(pager) );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData(pager) {
    const { leagueType } = this.props;
    const { resultTableData, sortClass } = this.state;

		var eroText = "";
		if (leagueType === myConstClass.LGTYPE_8B) {
			eroText = "ERO";
		}
		if (leagueType === myConstClass.LGTYPE_10B) {
			eroText = "TRO";
		}

		var showEroColumn = false;
		if ((leagueType === myConstClass.LGTYPE_8B) || (leagueType === myConstClass.LGTYPE_10B)) {
			showEroColumn = true;
		}

		var bDispPagination = true;
    if (pager.pages.length < 2) {
			bDispPagination = false;
		}

		return (
     	<div className="row">
     	<div className="col-12">

			<p>{pager.totalItems} parties jouées</p>
			
			<div className="table-responsive">
			<table className="table table-striped table-hover table-sm">
			<thead>
				<tr>
				<th id="colid.0" className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable}> Date </th>
				<th id="colid.1" className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable}> Joueur(s) </th>
				<th id="colid.2" className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable}> Adversaire(s) </th>
				<th></th>
				<th id="colid.3" className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable}> Pointage </th>
				
				{(showEroColumn) ?
				<th id="colid.4" className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable}> {eroText} </th>
				: null}

				<th id="colid.5" className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable}> Saison </th>
				</tr>
			</thead>

			<tbody>
				{resultTableData.map(this.createTableRow)}
			</tbody>
			</table>
			</div>

			{bDispPagination ? this.displayPagination(pager) : null}
			</div>
			</div>
		);
	}

	displayPagination(pager) {
		return (
      <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index} className={pager.currentPage === page ? 'active' : ''}>
              <a onClick={() => this.setPage(page)}>{page}</a>
          </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
      </ul>
		);
	}

	createTableRow(item, idx) {
    const { leagueType } = this.props;

		var badgeClass = 'badge-danger';
		var badgeText = 'D';
		var eroText = '';

		if (item.player1Score > item.player2Score) {
			badgeClass = 'badge-success';
			badgeText = 'V';
		}

		if (item.ero) {
			if (item.player1Score > item.player2Score) {
				eroText = "Pour";
			} else {
				eroText = "Contre";
			}
		}

		var showEroColumn = false;
		if ((leagueType === myConstClass.LGTYPE_8B) || (leagueType === myConstClass.LGTYPE_10B)) {
			showEroColumn = true;
		}

		return (
			<tr key={'te.' + idx}>
				<td>{moment(item.date).utc().format("YYYY-MM-DD")}</td>
				<td>{item.player1name}</td>
				<td>{item.player2name}</td>
				<td><span className={"badge " + badgeClass}>{badgeText}</span></td>
				<td>{item.player1Score + " - " + item.player2Score}</td>

				{(showEroColumn) ?
					<td>{eroText}</td>
				: null}

				<td>{item.seasonName}</td>
      </tr>
    );
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var { results, sortOrder, sortFieldIdx, pager } = this.state;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			if (colIdx === 2) {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		}

		var sortClass = [];
		for(var i = 0; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: colIdx,
			sortClass: sortClass
		});

		this.loadData(pager, colIdx, sortOrder);
	}

}

export default DashMod_GameResultsPlayerAll01;
